export const environment = {
  production: false,
  ENV_NAME: 'Quality Environment',
  BASE_URL: 'https://api.dgs.mosaic-qa.siemens-energy.cloud/',
  APP_URL: 'https://dgs.mosaic-qa.siemens-energy.cloud/',
  azuread: {
    clientId: '37db503d-3d76-4e25-aae8-68eb1de4a474',
    authority: 'https://login.microsoftonline.com/254ba93e-1f6f-48f3-90e6-e2766664b477',
    redirectUri: 'https://dgs.mosaic-qa.siemens-energy.cloud/callback',
    postLogoutRedirectUri: '/'
  }
};
